module.exports = __webpack_public_path__ + "media/images/country_flags/sv-9676627fcfbf624308d217035ef769a5.png";